import { h, proxyCustomElement, HTMLElement, createEvent, Host } from '@stencil/core/internal/client';
import { f as formatCurrency } from './utils2.js';
import { T as radioListItem } from './parts.js';
import { d as defineCustomElement$2 } from './form-control-help-text2.js';
import { d as defineCustomElement$1 } from './form-control-radio2.js';

const sezzleLogo = (h("img", { class: "sezzle-smart-button-logo-img", src: "https://media.sezzle.com/branding/2.0/Sezzle_Logo_FullColor.svg", alt: "Sezzle", style: {
        display: 'inline',
        width: '80px',
        marginLeft: '5px',
        marginTop: '-5px',
    } }));
const SezzlePaymentMethod = /*@__PURE__*/ proxyCustomElement(class SezzlePaymentMethod extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.paymentMethodOptionSelected = createEvent(this, "paymentMethodOptionSelected", 7);
        this.onPaymentMethodOptionClick = (e) => {
            e.preventDefault();
            this.paymentMethodOptionSelected.emit(this.paymentMethodOption);
        };
        this.initializeSezzleCheckout = () => {
            let resolveSezzlePromise;
            this.sezzlePromise = new Promise((resolve) => { resolveSezzlePromise = resolve; });
            const bnpl = this.bnpl;
            const amount = +this.paymentAmount; // convert to number
            const Checkout = window.Checkout;
            const checkout = new Checkout({
                mode: 'popup',
                publicKey: bnpl.provider_client_id,
                apiMode: bnpl.provider_mode,
                apiVersion: bnpl.provider_api_version,
            });
            checkout.sezzleButtonElement = this.sezzleButtonRef;
            checkout.init({
                onClick: function (event) {
                    event.preventDefault();
                    checkout.startCheckout({
                        checkout_url: bnpl.provider_checkout_url
                    });
                },
                onComplete: (event) => resolveSezzlePromise({ bnpl: event.data }),
                onCancel: (event) => resolveSezzlePromise({ bnpl: event.data }),
                onFailure: (event) => resolveSezzlePromise({ bnpl: event.data }),
            });
            this.sezzleCheckout = checkout;
            this.installmentPlan = this.sezzleCheckout.getInstallmentPlan(amount);
        };
    }
    componentDidRender() {
        this.scriptRef.onload = () => {
            this.sezzleButtonRef = document.createElement('button');
            this.initializeSezzleCheckout();
        };
    }
    async resolvePaymentMethod(insuranceValidation) {
        if (!insuranceValidation.isValid) {
            return { validationError: true };
        }
        this.sezzleButtonRef.click();
        return this.sezzlePromise;
    }
    render() {
        var _a, _b, _c;
        return (h(Host, { key: '4ae50e7bbb15d0049d069edacd0d95ba7c13dbe5', class: "payment-method" }, h("script", { key: '42a0590d89626ba7a93852e421eb121626b48375', src: "https://checkout-sdk.sezzle.com/checkout.min.js", async: true, ref: (el) => (this.scriptRef = el) }), h("div", { key: '31a2a72650486c258267c6d4de3723f7afa5b063', class: "radio-list-item p-3", part: radioListItem, onClick: this.onPaymentMethodOptionClick }, h("form-control-radio", { key: 'eac1adbcd82fcb4f9c440c53c40ce34af6092991', name: "paymentMethodType", value: (_a = this.paymentMethodOption) === null || _a === void 0 ? void 0 : _a.id, checked: this.isSelected, label: h("div", null, h("div", null, "Buy now, pay later with ", sezzleLogo), this.installmentPlan && (h("small", null, h("span", null, (_b = this.installmentPlan) === null || _b === void 0 ? void 0 : _b.installments.length), "\u00A0", h("span", null, this.installmentPlan.schedule, " payments of"), "\u00A0", h("span", { class: "fw-bold" }, formatCurrency((_c = this.installmentPlan) === null || _c === void 0 ? void 0 : _c.installments[0].amountInCents))))) }))));
    }
}, [0, "justifi-sezzle-payment-method", {
        "bnpl": [8],
        "clientId": [1, "client-id"],
        "accountId": [1, "account-id"],
        "paymentMethodOption": [16, "payment-method-option"],
        "isSelected": [4, "is-selected"],
        "paymentAmount": [2, "payment-amount"],
        "installmentPlan": [32],
        "sezzleCheckout": [32],
        "sezzlePromise": [32],
        "resolvePaymentMethod": [64]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["justifi-sezzle-payment-method", "form-control-help-text", "form-control-radio"];
    components.forEach(tagName => { switch (tagName) {
        case "justifi-sezzle-payment-method":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, SezzlePaymentMethod);
            }
            break;
        case "form-control-help-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "form-control-radio":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { SezzlePaymentMethod as S, defineCustomElement as d };
